import Container from '~/components/sanity/Container.vue';
import GreenCheck from '~/components/sanity/GreenCheck.vue';
import GreyCross from '~/components/sanity/GreyCross.vue';
export default {
  name: 'CardComparison',
  components: {
    Container,
    GreenCheck,
    GreyCross
  },
  props: {
    styles: Object
  },
  computed: {
    style() {
      if (!this.styles) {
        return {
          color: '#FFFFFF',
          backgroundColor: '#000000'
        };
      }
      let style = {
        color: this.styles.color || '#FFFFFF'
      };
      if (this.styles.backgroundType === 'image') {
        style = {
          ...style,
          backgroundImage: `url(${this.styles.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      } else if (this.styles.backgroundType === 'color') {
        style.backgroundColor = this.styles.backgroundColor;
      } else {
        style.backgroundColor = '#000000';
      }
      return style;
    }
  }
};